export default __webpack_public_path__ + "static/media/market icon white.85f3af67.svg";